import React from 'react'

function Role(props: any) {
  const { role } = props
  return <span> {role} </span>
}

export default Role
